import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import MeditationService from '../meditationService';

const prefix = 'MEDITATION_VIEW';

const meditationViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: meditationViewActions.FIND_STARTED,
      });

      const record = await MeditationService.find(id);
      
      dispatch({
        type: meditationViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: meditationViewActions.FIND_ERROR,
      });

      getHistory().push('/meditation');
    }
  },
};

export default meditationViewActions;
